import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {getSchoolYear} from "../../../../utils/authority";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import BusRouteController from "../../../../services/system/bus/bus-route-controller";
import AutoSearchPeople from "../../../../components/auto-search-people";
registerLocale("vi", vi);


class BusManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            busRouteName: "",
            assistant1Id: "",
            assistant1Name: "",
            assistant1Username: "",

            driverId: "",
            driverName: "",
            driverUsername: "",

            state: "ACTIVE",
            listData: [],

            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tên tuyến xe",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "startDate",
                    name: "Tài xế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Phụ xe 1",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "status",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListRouteBus()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListRouteBus();
            }
        );
    };
    getListRouteBus() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            assistant1Name: this.state.assistant1Name,
            busRouteName: this.state.busRouteName,
            driverName: this.state.driverName,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
            state: this.state.state,
        };
        BusRouteController.search(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    onhandleSearch() {
        this.getListRouteBus()
    }
    onHandleRefresh() {
        this.setState({
            busRouteName: "",
            assistant1Id: "",
            assistant1Name: "",
            assistant1Username: "",

            driverId: "",
            driverName: "",
            driverUsername: "",

            state: "ACTIVE",
            listData: [],
            pageNumber: 0,
            totalItem: 0,
        }, ()=>{
            this.getListRouteBus()
        });
    }

    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Đang khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-bus" parentClass="bus-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý tuyến xe bus"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tên tuyến xe bus</label>
                                                <input
                                                    placeholder="Nhập tên tuyến xe"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.busRouteName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({busRouteName: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        }, () =>{
                                                            this.getListRouteBus()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderStatus()}
                                                </select>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item">Tên tài xế</label>
                                                <input
                                                    placeholder="Nhập tên tài xế"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.driverName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({driverName: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex p-1 pr-md-3">
                                                <label className="col-md-4 label-item pl-0">Tên phụ xe</label>
                                                <AutoSearchPeople
                                                    principalId={this.state.assistant1Id}
                                                    principalName={this.state.assistant1Name}
                                                    principalUsername={this.state.assistant1Username}
                                                    onUpdateData={(principalId, principalUsername, principalName) => this.setState({assistant1Id: principalId, assistant1Name: principalName, assistant1Username: principalUsername}, ()=>{this.onhandleSearch()})}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>

                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm ml-3"
                                                    onClick={() => this.onHandleRefresh()}
                                                >
                                                    Refresh
                                                </button>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                 style={{
                                                     alignItems: "center",
                                                     justifyContent: "right"
                                                 }}>
                                                <LinkPlus
                                                    style={{color: '#000'}}
                                                    to={{
                                                        pathname: "/ad-sas-school/them-moi-tuyen-xe",
                                                        state: {
                                                            fromDashboard: true,
                                                        }
                                                    }}
                                                >
                                                    <button
                                                        style={{height: 35, marginRight: 12}}
                                                        type="button"
                                                        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    >
                                                        Thêm mới
                                                    </button>
                                                </LinkPlus>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                        let a = "";
                                                        let descend = "";
                                                        if (data.sortAsc == null) {
                                                            // a = "id=asc";
                                                            a = "id";
                                                            descend = 'DESC'
                                                        } else {
                                                            a = data.sortId;
                                                            descend = data.sortAsc ? 'ASC' : 'DESC'
                                                        }
                                                        this.setState(
                                                            {
                                                                sort: a,
                                                                descending: descend
                                                            },
                                                            () => this.getListRouteBus()
                                                        );
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.driverName}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.assistant1}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.state=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Khóa</span> : <span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                <LinkPlus
                                                                    style={{color: '#000'}}
                                                                    to={{
                                                                        pathname: "/ad-sas-school/sua-tuyen-xe-bus",
                                                                        search: createSearchParams({
                                                                            id: `${row.id}`
                                                                        }).toString(),
                                                                        state: {
                                                                            fromDashboard: true,
                                                                            id: row.id
                                                                        }
                                                                    }}
                                                                >
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                </LinkPlus>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BusManagement;
